module.exports = __webpack_public_path__ + "static/img/case4.75827d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/case4.png
// module id = 32
// module chunks = 0